module.exports = __webpack_public_path__ + "static/john-64c1d71d11e01fdafe5e9ac593e711b3.png";